import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Suspense, useState } from 'react'
import { useDispatch } from 'react-redux'
import { login } from '../store/slices/authSlice'
import MegaMenu from './header/MegaMenu'
import Footer from './footer/Footer'
import ScrollToTop from './ScrollToTop'
import Chatbot from './chatbot/Chatbot'
import MeetOurDoctors from './MeetOurDoctors'
import DownloadBrochure from './DownloadBrochure'
import AccessibilityWidgetButton from './AccessibilityWidgetButton'
import CookiePolicyWindow from './CookiePolicyWindow'
import I18nProvider from './I18nProvider'
import ScrollToTopOnNavigate from './ScrollToTopOnNavigate'
import PageSuspenseFallback from './PageSuspenseFallback'
import LoginModal from './auth/LoginModal'
import JoinUsModal from './auth/JoinUsModal'
import SignupModal from './auth/SignupModal'

const LayoutWithSuspense = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [isJoinUsOpen, setIsJoinUsOpen] = useState(false)
  const [isSignupOpen, setIsSignupOpen] = useState(false)
  const [verifiedMobile, setVerifiedMobile] = useState('')
  const [loginMode, setLoginMode] = useState('login')
  const joinUsPath = import.meta.env.VITE_JOIN_US_PATH || ''

  const handleJoinUs = () => {
    setIsJoinUsOpen(true)
  }

  const handleSignUp = () => {
    setIsJoinUsOpen(false)
    setLoginMode('signup')
    setIsLoginOpen(true)
  }

  const handleOpenSignup = (mobile) => {
    setVerifiedMobile(mobile)
    setIsLoginOpen(false)
    setIsSignupOpen(true)
  }

  const handleSignupSuccess = (patient) => {
    setIsSignupOpen(false)
    dispatch(login(patient))
  }

  const handleLoginSuccess = (patient) => {
    setIsLoginOpen(false)
    dispatch(login(patient))
  }

  const handleLogin = () => {
    setLoginMode('login')
    setIsLoginOpen(true)
  }

  return (
    <I18nProvider>
      <ScrollToTopOnNavigate />
      <div className="min-h-screen bg-white text-gray-900 antialiased font-sans">
        <MegaMenu onLoginClick={handleLogin} onJoinUsClick={handleJoinUs} onOpenSignup={handleOpenSignup} />
        <main>
          <Suspense fallback={<PageSuspenseFallback />} key={location.pathname}>
            <Outlet />
          </Suspense>
        </main>
        <div className="h-auto w-[150px] flex fixed bottom-24 right-2 z-50 shadow-none flex-col max-md:w-auto max-md:h-auto max-md:bottom-4 max-md:right-2 max-md:items-end">
          <div className="w-full md:items-center max-md:items-end mt-4 flex flex-col gap-2 z-50">
            {/* TopWeb.LK Badge */}
            <div className="mb-1">
              <a
                href="https://ebadge.bestweb.lk/api/v1/clicked/medica.lk/TopWeb/2026-June/Qualified"
                target="_blank"
                rel="noopener noreferrer"
                className="block transition-transform hover:scale-105 duration-300"
              >
                <img
                  src="https://ebadge.bestweb.lk/eBadgeSystem/domainNames/medica.lk/TopWeb/2026-June/Qualified/image.png"
                  alt="TopWeb.LK Qualified Badge"
                  width={150}
                  height={150}
                  className="object-contain w-[120px] h-[120px] md:w-[150px] md:h-[150px] drop-shadow-md"
                />
              </a>
            </div>
            <div className="hidden md:block"><AccessibilityWidgetButton /></div>
            <Chatbot />
            <DownloadBrochure />
            <MeetOurDoctors />
            <ScrollToTop />
          </div>
        </div>
        <LoginModal
          open={isLoginOpen}
          defaultMode={loginMode}
          onClose={() => setIsLoginOpen(false)}
          onJoinUs={handleSignUp}
          onOpenSignup={handleOpenSignup}
          onSuccess={handleLoginSuccess}
        />
        <JoinUsModal
          open={isJoinUsOpen}
          onClose={() => setIsJoinUsOpen(false)}
          onSignUp={handleSignUp}
        />
        <SignupModal
          open={isSignupOpen}
          onClose={() => setIsSignupOpen(false)}
          verifiedMobile={verifiedMobile}
          onSuccess={handleSignupSuccess}
        />
        <CookiePolicyWindow />
        <Footer />
      </div>
    </I18nProvider>
  )
}

export default LayoutWithSuspense
